module.exports = __webpack_public_path__ + "media/images/skype-4f3f38aa0e60237771ca7794ab2d47c9.png";